import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, getDocs, onSnapshot, query } from 'firebase/firestore';
import { promptsLoadedAction } from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const usePromptLoader = () => {
  const [options, setOptions] = useState({ execute: false });
  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'Preloaded', path: 'prompts' }));

    return onSnapshot(
      collection(db, 'prompts'),
      async querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          items.push(dataItem);
        });

        await Promise.all(
          items.map(async dataItem => {
            const placeholdersSnap = await getDocs(
              query(
                collection(db, `prompts/${dataItem.id}/prompt_placeholders`)
              )
            );

            const placeholders = [];
            placeholdersSnap.forEach(placeholder => {
              placeholders.push(placeholder.data());
            });

            dataItem.placeholders = placeholders;

            const continuationsSnap = await getDocs(
              query(
                collection(db, `prompts/${dataItem.id}/prompt_continuations`)
              )
            );

            const continuations = [];
            continuationsSnap.forEach(continuation => {
              continuations.push(continuation.data());
            });
            dataItem.continuations = continuations;

            const resultMappingsSnap = await getDocs(
              query(
                collection(
                  db,
                  `prompts/${dataItem.id}/openai_result_field_mappings`
                )
              )
            );

            const mappings = [];
            resultMappingsSnap.forEach(mapping => {
              mappings.push(mapping.data());
            });
            dataItem.mappings = mappings;
          })
        );

        dispatch(promptsLoadedAction(items));
      },
      error => {
        console.error('usePromptLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadPrompts: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default usePromptLoader;
